// 用户相关接口
import request from '@/utils/request'
const preFixUrl = '/auth'
/**
 * 用户注册
 * @param {*} params
 * @returns
 */
export const userLogin = params => {
  return request({
    url: `${preFixUrl}/sso`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    },
    params
  })
}

export const getUserInfo = params => {
  return request({
    url: `${preFixUrl}/getUserInfo`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    },
    params
  })
}
